<template>
    <div class="feed-back">
        <home-nav></home-nav>
        <div class="feed-back-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item class="itemOne" :to="{ path: '/home' }">保时达</el-breadcrumb-item>
                <el-breadcrumb-item class="active">意见反馈</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="feed-back-box">
            <div class="feed-back-box-textarea">
                <div class="feed-back-box-tit">
                    反馈建议
                </div>
                <textarea name=""
                          class="textarea-box"
                          id=""
                          cols="30"
                          rows="10"
                          placeholder="我们非常重视您的建议，请在这里填写告诉我们"
                          v-model="textarea">
                </textarea>
            </div>

            <div class="feed-back-box-textarea">
                <div class="feed-back-box-tit">
                    联系电话
                </div>
                <el-input class="telephone-box"
                          v-model="telephone"
                          placeholder="请填写您的手机号码"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          maxlength="11"
                >
                </el-input>
                <div class="feed-back-box-text">
                    （保时达将对您的联系方式严格保密）
                </div>
            </div>

            <div class="submitBtnBox">
                <div class="submitBtn" @click="feedBtn()">提交</div>
            </div>
        </div>

        <home-footer></home-footer>
    </div>
</template>

<script>
    import HomeNav from '@/components/homeNav';
    import HomeFooter from '@/components/homeFooter';

    export default {
        name: "feedBack",
        components: {
            HomeNav,
            HomeFooter
        },
        data() {
            return {
                textarea: '',
                telephone: '',
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            this.getUrlCurrent();
        },
        methods: {
            feedBtn() {
                var phone = this.telephone;
                var textarea = this.textarea;
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(phone)) {
                    // layer.msg('请填写正确的手机号码！', {icon: 2});
                    this.$message('请填写正确的手机号码！');
                    return;
                }
                if(textarea.length < 1 || textarea == ''){
                    // layer.msg('您输入的内容为空！', {icon: 2});
                    this.$message('您输入的内容为空！');
                }

                /*var index;
                layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                this.$axios.post('/FeedbackSub', {
                    content: textarea,
                    contact_mobile: phone
                }).then((res) => {
                    // layer.close(index);
                    res = res.data;
                    // console.log(res);
                    if (res.status == 200) {
                        // layer.msg('提交成功，感谢您的反馈！', {icon: 1});
                        this.$message('提交成功，感谢您的反馈！');
                        this.textarea = '';
                        this.telephone = '';
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    // layer.close(index)
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
    @import './feedBack.css';
</style>



// WEBPACK FOOTER //
// src/pages/feedBack/feedBack.vue